
import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
// GITagRegistration.jsx


const GITagRegistration = () => {
  
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  return (
    <div className="service-page">

      <Helmet>
        <title>
          GI Tag Registration Service in India | Geographical Indication Registration
        </title>

        <meta
          name="description"
          content="Get Geographical Indication (GI Tag) Registration for region-based products in India. Protect traditional products, cultural identity, and regional reputation legally."
        />

        <meta
          name="keywords"
          content="GI Tag Registration, Geographical Indication Registration, GI Certificate India, Regional Product Protection, GI Filing"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>Geographical Indication (GI Tag) Registration</h1>

        <p>
          Protect Traditional & Region-Based Products with Legal Recognition
        </p>
         <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="card">
          <p>
            Geographical Indication (GI Tag) Registration protects products that
            originate from a specific geographical region and possess unique
            qualities, reputation, or characteristics linked to that location.
          </p>

          <p>
            GI registration helps preserve traditional products, regional
            identity, cultural heritage, and market value.
          </p>
        </div>
      </section>

      {/* WHAT IT PROTECTS */}
      <section className="service-section">
        <h2>What Does GI Tag Protect?</h2>

        <div className="service-grid-box">

          <div className="card">
            Traditional Regional Products
          </div>

          <div className="card">
            Agricultural Goods
          </div>

          <div className="card">
            Handicrafts & Handloom Products
          </div>

          <div className="card">
            Food Products
          </div>

          <div className="card">
            Natural Goods
          </div>

          <div className="card">
            Cultural & Heritage Products
          </div>

        </div>
      </section>

      {/* EXAMPLES */}
      <section className="service-section">
        <h2>Examples of GI Tagged Products</h2>

        <div className="service-grid-box">

          <div className="card">
            Darjeeling Tea
          </div>

          <div className="card">
            Banarasi Saree
          </div>

          <div className="card">
            Mysore Silk
          </div>

          <div className="card">
            Alphonso Mango
          </div>

          <div className="card">
            Kashmir Saffron
          </div>

          <div className="card">
            Pashmina Shawls
          </div>

        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of GI Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            ✔ Legal protection for regional products
          </div>

          <div className="card">
            ✔ Prevents unauthorized use
          </div>

          <div className="card">
            ✔ Preserves cultural identity
          </div>

          <div className="card">
            ✔ Increases market value
          </div>

          <div className="card">
            ✔ Enhances export opportunities
          </div>

          <div className="card">
            ✔ Builds consumer trust
          </div>

        </div>
      </section>

      {/* VALIDITY */}
      <section className="service-section">
        <h2>GI Registration Validity</h2>

        <div className="card">
          <p>
            GI Tag registration is valid for{" "}
            <strong>10 years</strong> and can be renewed repeatedly after expiry.
          </p>
        </div>
      </section>

      {/* WHO CAN APPLY */}
      <section className="service-section">
        <h2>Who Can Apply for GI Registration?</h2>

        <div className="service-grid-box">

          <div className="card">
            Associations
          </div>

          <div className="card">
            Producer Groups
          </div>

          <div className="card">
            Cooperative Societies
          </div>

          <div className="card">
            Organizations
          </div>

          <div className="card">
            Government Bodies
          </div>

          <div className="card">
            Regional Communities
          </div>

        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">

          <div className="card">
            Applicant Identity Proof
          </div>

          <div className="card">
            Address Proof
          </div>

          <div className="card">
            Product Description
          </div>

          <div className="card">
            Proof of Geographical Origin
          </div>

          <div className="card">
            Historical Records (if available)
          </div>

          <div className="card">
            Producer Group Details
          </div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>GI Registration Process</h2>

        <div className="service-grid-box">

          <div className="card">
            Product & Region Analysis
          </div>

          <div className="card">
            Documentation Preparation
          </div>

          <div className="card">
            GI Application Filing
          </div>

          <div className="card">
            Examination by GI Registry
          </div>

          <div className="card">
            Publication & Objection Handling
          </div>

          <div className="card">
            GI Registration Certificate Issuance
          </div>

        </div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our GI Registration Services Include</h2>

        <div className="card">
          <ul>
            <li>Eligibility assessment for GI filing</li>
            <li>Documentation & application drafting</li>
            <li>GI registry filing support</li>
            <li>Objection handling assistance</li>
            <li>End-to-end registration support</li>
            <li>Renewal & compliance guidance</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card">
          <ul>
            <li>✔ Experienced IPR professionals</li>
            <li>✔ Complete GI filing assistance</li>
            <li>✔ Affordable & transparent pricing</li>
            <li>✔ Proper documentation support</li>
            <li>✔ End-to-end compliance guidance</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Protect Your Regional Product Identity</h2>

        <p>
          Secure legal recognition and preserve the uniqueness of your
          traditional product through GI registration.
        </p>

        <button>Apply for GI Tag</button>
      </section> */}

      
         <div className="cta" ref={contactRef}>
                <h2>Protect Your Regional Product Identity</h2>
              
        <p>
          Secure legal recognition and preserve the uniqueness of your
          traditional product through GI registration.
        </p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>


    </div>
  );
};

export default GITagRegistration;